import { render, staticRenderFns } from "./CashSalary.vue?vue&type=template&id=212e6b54&scoped=true"
import script from "./CashSalary.vue?vue&type=script&lang=js"
export * from "./CashSalary.vue?vue&type=script&lang=js"
import style0 from "./CashSalary.vue?vue&type=style&index=0&id=212e6b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e6b54",
  null
  
)

export default component.exports